import { store } from "@/store/index";
export function arrayToCsv(data) {
  return data
    .map(
      row =>
        row
          .map(String) // convert every value to String
          .map(v => v.replaceAll('"', '""')) // escape double colons
          .map(v => `"${v}"`) // quote it
          .join(";") // comma-separated
    )
    .join("\r\n") // rows starting on new lines
}
export function downloadBlob(content, filename, contentType) {
  // Create a blob
  let BOM = "\uFEFF"
  let blob = new Blob([`${BOM}${content}`], { type: contentType })
  let url = URL.createObjectURL(blob)

  // Create a link to download it
  let pom = document.createElement("a")
  pom.href = url
  pom.setAttribute("download", filename)
  pom.click()
}
export const targetObjToString = (obj = 0) => {
  const measure = obj.measure ? obj.measure : "";
  const group = obj.group ? obj.group : "";
  const age_from = obj.age_from ? obj.age_from : "";
  const age_to = obj.age_to ? obj.age_to : "";
  const consolidation = obj.consolidation ? obj.consolidation : "";
  const targetString =
    measure + ", " + group + age_from + "-" + age_to + ", " + consolidation;

  return targetString;
};
export function dateToyymmddFormat(item) {
  if (item == null) return "";

  let date = new Date(item);
  return date.toLocaleDateString("sv-SE", {});
}

export function dateToTimeStamp(item) {
  if (item == null) return null;
  let date = new Date(item);
  return date.toLocaleTimeString("sv-SE", {
    hour: "2-digit",
    minute: "2-digit",
    hour12: false
  });
}
export function download(content, filename, contentType) {
  if (!contentType) contentType = "application/octet-stream";
  let a = document.createElement("a");
  content = "\ufeff" + content;
  let blob = new Blob([content], { type: contentType });
  a.href = window.URL.createObjectURL(blob);
  a.download = filename;
  a.click();
  window.URL.revokeObjectURL(a.href); //Release the blob object
}
function overlapping(a, b) {
  const getMinutes = s => {
    const p = s.split(":").map(Number);
    return p[0] * 60 + p[1];
  };
  return (
    getMinutes(a.end) > getMinutes(b.start) &&
    getMinutes(b.end) > getMinutes(a.start)
  );
}
export function isOverlapping(arr) {
  let i, j;
  for (i = 0; i < arr.length - 1; i++) {
    for (j = i + 1; j < arr.length; j++) {
      let previousTime = arr[i].daypart.split("-");
      let nextTime = arr[j].daypart.split("-");
      if (
        overlapping(
          { start: previousTime[0], end: previousTime[1] },
          { start: nextTime[0], end: nextTime[1] }
        )
      ) {
        return true;
      }
    }
  }
  return false;
}
export function sortObject(obj) {
  return Object.keys(obj)
    .sort()
    .reduce(function(result, key) {
      result[key] = obj[key];
      return result;
    }, {});
}
export function unselectFilteredOutChannels(selectedChannels, newChannels) {
  let newChannelsFiltered = { ...newChannels };
  let selectedChannelHousesKeys = Object.keys(selectedChannels).sort();
  for (var name in newChannelsFiltered) {
    if (!selectedChannelHousesKeys.includes(name)) {
      delete newChannelsFiltered[name];
    }
  }
  Object.values(sortObject(newChannelsFiltered)).reduce(
    (result, channels, indexChannelHouse) => {
      let selectedChannelsInChannelHouse =
        selectedChannels[selectedChannelHousesKeys[indexChannelHouse]];
      let channelsValues = channels.map(c => c.item);
      for (let i = 0; i < selectedChannelsInChannelHouse.length; i++) {
        if (!channelsValues.includes(selectedChannelsInChannelHouse[i])) {
          let index = selectedChannelsInChannelHouse.indexOf(
            selectedChannelsInChannelHouse[i]
          );
          selectedChannelsInChannelHouse.splice(index, 1);
        }
      }
    },
    {}
  );
}
export function compareNumbers(a, b) {
  return a - b;
}
export const objectArraysEqual = (o1a, o2a) => {
  let objectArraysEqual = o1a.length !== o2a.length ? false : true;
  if (objectArraysEqual) {
    for (let i = 0; i < o1a.length; i++) {
      objectArraysEqual =
        Object.keys(o1a[i]).length === Object.keys(o2a[i]).length &&
        Object.keys(o1a[i]).every(p => o1a[i][p] === o2a[i][p]);
    }
  }
  return objectArraysEqual;
};
export function arraysEqual(a, b) {
  if (a === b) return true;
  if (a == null || b == null) return false;
  if (a.length !== b.length) return false;
  a.sort();
  b.sort();
  for (var i = 0; i < a.length; ++i) {
    if (a[i] !== b[i]) return false;
  }
  return true;
}
export function isDateNotBetweenTwoDates(isThisDateBetween, datefrom, dateto) {
  datefrom.setHours(0, 0, 0);
  dateto.setHours(0, 0, 0);
  isThisDateBetween.setHours(0, 0, 0);
  if (
    isThisDateBetween.getTime() <= dateto.getTime() &&
    isThisDateBetween.getTime() >= datefrom.getTime()
  )
    return false;
  return true;
}
export function checkCookieConsent() {
  const isVideoInHome = store.getters.getIsVideoInHomeSubdomain;
  const cookieName = isVideoInHome ? "MMS_UserConsentStatus_VideoInHome" : "MMS_UserConsentStatus_TvAnalys";
  const consentCookie = document.cookie
    .split("; ")
    .find(row => row.startsWith(`${cookieName}=`));

  return consentCookie ? true : false;
}

export function consentToCookies() {
  const isVideoInHome = store.getters.getIsVideoInHomeSubdomain;
  const date = new Date();
  date.setMonth(date.getMonth() + 3);
  const cookieDomain = isVideoInHome ? store.getters.getAppCookieDomainVideoInHome : store.getters.getAppCookieDomain;
  const cookieName = isVideoInHome ? "MMS_UserConsentStatus_VideoInHome" : "MMS_UserConsentStatus_TvAnalys";
  document.cookie = `${cookieName}=true; expires=${date.toUTCString()}; domain=${cookieDomain}; path=/; Secure; SameSite=Lax`;
}
export const splitDayParts = dayparts => {
  let dayPartList = [];
  for (let i = 0; i < dayparts.length; i++) {
    if (dayparts[i].split == "Period") {
      dayPartList.push(dayparts[i].daypart);
      continue;
    }
    dayPartList = dayPartList.concat(getIntervals(dayparts[i]));
  }
  return dayPartList;
};
const getIntervals = daypart => {
  let dayPartFrom = new Date();
  dayPartFrom.setHours(
    parseInt(daypart.time_from),
    parseInt(daypart.minute_from),
    0,
    0
  );
  let dayPartTo = new Date();
  let daypartMinuteTo = parseInt(daypart.minute_to);
  if (daypart.split === "1") daypartMinuteTo++;
  dayPartTo.setHours(parseInt(daypart.time_to), daypartMinuteTo, 0, 0);
  if (daypart.split !== "1")
    checkIfMinIsAllowed(dayPartFrom, parseInt(daypart.split));
  let getTimeIntervals = (time1, time2) => {
    var arr = [];
    while (time1 < time2) {
      let hour = formatHour(time1);
      let split = parseInt(daypart.split);
      let firstPart = `${hour}:${time1.toTimeString().substring(3, 5)}`;
      let secondPartMin = time1.getMinutes() + split - 1;
      let secondPart = `-${hour}:${secondPartMin}`;
      let secondPartDate = new Date();
      secondPartDate.setHours(hour, secondPartMin, 0, 0);
      if (secondPartDate > time2) break;
      if (daypart.split === "1") arr.push(`${firstPart}-${firstPart}`);
      else arr.push(firstPart + secondPart);
      time1.setMinutes(time1.getMinutes() + split);
    }
    return arr;
  };
  return getTimeIntervals(dayPartFrom, dayPartTo);
};
const checkIfMinIsAllowed = (time, split) => {
  let min = time.getMinutes();
  let hour = time.getHours();
  let allowedMinutes = [];
  if (split == 15) allowedMinutes = [0, 15, 30, 45];
  else if (split == 30) allowedMinutes = [0, 30];
  else allowedMinutes = [0];
  let minIsAllowed = allowedMinutes.includes(min);
  if (minIsAllowed) return;
  let allowedMinDayPartFrom = new Date();
  allowedMinDayPartFrom.setHours(hour, min + split, 0, 0);
  let closest = findClosestDownwardNumber(
    allowedMinutes,
    allowedMinDayPartFrom.getMinutes()
  );
  time.setHours(allowedMinDayPartFrom.getHours(), closest);
};
const findClosestDownwardNumber = (allowedMinutes, goal) => {
  var closest = null;
  for (const element of allowedMinutes) {
    if (
      element <= goal &&
      (closest == null || goal - element < goal - closest)
    ) {
      closest = element;
    }
  }
  return closest;
};
const formatHour = time => {
  let hour = time.toTimeString().substring(0, 2);
  if (time.getHours() == 0) hour = "24";
  else if (time.getHours() == 1) hour = "25";
  return hour;
};
export function sortAsWeekday(sortItems, sortInfo) {
  const sorter = {
    // "sunday": 0, // << if sunday is first day of week
    måndag: 1,
    tisdag: 2,
    onsdag: 3,
    torsdag: 4,
    fredag: 5,
    lördag: 6,
    söndag: 7
  };
  if (sortInfo.sortDesc) {
    sortItems.sort(function sortByDay(a, b) {
      let day1 = a[sortInfo.sortBy].toLowerCase();
      let day2 = b[sortInfo.sortBy].toLowerCase();
      return sorter[day2] - sorter[day1];
    });
  } else {
    sortItems.sort(function sortByDay(a, b) {
      let day1 = a[sortInfo.sortBy].toLowerCase();
      let day2 = b[sortInfo.sortBy].toLowerCase();
      return sorter[day1] - sorter[day2];
    });
  }
}
export function getPanelDay(startDate, endDate) {
  let panelDay = new Date((startDate.getTime() + endDate.getTime()) / 2);
  let difference = endDate.getTime() - startDate.getTime();
  let days = Math.ceil(difference / (1000 * 3600 * 24)) + 1;
  let isOdd = days % 2;
  if (isOdd == 0) {
    panelDay.setDate(panelDay.getDate() + 1);
    return panelDay;
  }
  return panelDay;
}
export function sortChannels(programsQueryBeforeChange, query) {
  const hasOwnProperty = Object.prototype.hasOwnProperty;
  if (programsQueryBeforeChange.channels) {
    for (let channel in programsQueryBeforeChange.channels) {
      if (hasOwnProperty.call(programsQueryBeforeChange.channels, channel)) {
        programsQueryBeforeChange.channels[channel].sort((a, b) => a - b);
      }
    }
  }
  if (query.channels) {
    for (let channel in query.channels) {
      if (hasOwnProperty.call(query.channels, channel)) {
        query.channels[channel].sort((a, b) => a - b);
      }
    }
  }
}
